import { useState, useEffect, useRef } from "react";
import logo from '../src/color-replaced.png';
const TARGET_DATE = new Date("2025-09-01T00:00:00");

function useCountdown() {
  const [time, setTime] = useState({ d: "00", h: "00", m: "00", s: "00" });
  useEffect(() => {
    const tick = () => {
      let diff = Math.max(0, TARGET_DATE - new Date());
      const d = Math.floor(diff / 86400000); diff %= 86400000;
      const h = Math.floor(diff / 3600000);  diff %= 3600000;
      const m = Math.floor(diff / 60000);    diff %= 60000;
      const s = Math.floor(diff / 1000);
      setTime({
        d: String(d).padStart(2, "0"),
        h: String(h).padStart(2, "0"),
        m: String(m).padStart(2, "0"),
        s: String(s).padStart(2, "0"),
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);
  return time;
}

function LipstickUnderline() {
  const stageRef = useRef(null);
  const canvasRef = useRef(null);
  const lipRef    = useRef(null);
  const didRun    = useRef(false);

  useEffect(() => {
    const delay = setTimeout(() => {
      if (didRun.current) return;
      didRun.current = true;
      run();
    }, 1400);
    return () => clearTimeout(delay);
  }, []);

  function run() {
    const stage  = stageRef.current;
    const canvas = canvasRef.current;
    const lip    = lipRef.current;
    if (!stage || !canvas || !lip) return;

    canvas.width  = stage.offsetWidth;
    canvas.height = stage.offsetHeight;
    const W = canvas.width, H = canvas.height;
    const ctx = canvas.getContext("2d");
    const x0 = W * 0.02, x1 = W * 0.98;
    const y  = H * 0.62;

    function drawLine(prog) {
      ctx.clearRect(0, 0, W, H);
      const cx = x0 + (x1 - x0) * prog;
      ctx.save();
      ctx.lineCap = "round";
      ctx.beginPath(); ctx.moveTo(x0, y); ctx.lineTo(cx, y);
      ctx.strokeStyle = "#c0003c"; ctx.lineWidth = 3.5; ctx.globalAlpha = 1; ctx.stroke();
      ctx.beginPath(); ctx.moveTo(x0, y - 1); ctx.lineTo(cx, y - 1);
      ctx.strokeStyle = "#f0205a"; ctx.lineWidth = 1.2; ctx.globalAlpha = 0.45; ctx.stroke();
      ctx.beginPath(); ctx.moveTo(x0, y + 2.5); ctx.lineTo(cx, y + 2.5);
      ctx.strokeStyle = "#800020"; ctx.lineWidth = 1; ctx.globalAlpha = 0.35; ctx.stroke();
      ctx.restore();
    }

    function posLip(px) {
      const angle = 32, rad = angle * Math.PI / 180;
      const tipX = 17, tipY = 7;
      const lx = px - tipX * Math.cos(rad) + tipY * Math.sin(rad);
      const ly = y   - tipX * Math.sin(rad) - tipY * Math.cos(rad) - 2;
      lip.style.transform = `rotate(${angle}deg)`;
      lip.style.left = lx + "px";
      lip.style.top  = ly + "px";
    }

    function ease(t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; }

    const dur = 1000, pause = 300;
    let t0 = null, phase = "in", pauseT = null;
    lip.style.opacity = "1";
    posLip(x0 - 40);

    function tick(ts) {
      if (!t0) t0 = ts;
      const el = ts - t0;
      if (phase === "in") {
        const p = Math.min(el / dur, 1), e = ease(p);
        drawLine(e); posLip(x0 + (x1 - x0) * e);
        if (p < 1) requestAnimationFrame(tick);
        else { phase = "pause"; pauseT = ts; requestAnimationFrame(tick); }
      } else if (phase === "pause") {
        drawLine(1); posLip(x1);
        if (ts - pauseT < pause) requestAnimationFrame(tick);
        else { phase = "out"; t0 = ts; requestAnimationFrame(tick); }
      } else {
        const p = Math.min(el / (dur * 0.55), 1), e = ease(p);
        drawLine(1); posLip(x1 + (W + 40 - x1) * e);
        if (p < 1) requestAnimationFrame(tick);
        else lip.style.opacity = "0";
      }
    }
    requestAnimationFrame(tick);
  }

  return (
    <div ref={stageRef} style={{ position: "relative", height: 14, width: "100%", marginTop: -2 }}>
      <canvas ref={canvasRef} style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }} />
      <div ref={lipRef} style={{ position: "absolute", top: 0, left: 0, zIndex: 3, opacity: 0, willChange: "transform" }}>
        <svg width="34" height="82" viewBox="0 0 34 82" fill="none" style={{ filter: "drop-shadow(1px 3px 10px rgba(180,0,50,.55))" }}>
          <rect x="6" y="53" width="22" height="27" rx="3" fill="#1a1a1a"/>
          <rect x="6" y="53" width="9"  height="27" rx="3" fill="#242424"/>
          <rect x="6" y="53" width="22" height="4"  rx="1" fill="#2e2e2e"/>
          <rect x="4" y="49" width="26" height="6"  rx="2" fill="#c9a96e"/>
          <rect x="4" y="49" width="11" height="6"  rx="2" fill="#dcc07a" opacity=".45"/>
          <rect x="8" y="27" width="18" height="24" rx="2" fill="#c0003c"/>
          <rect x="8" y="27" width="7"  height="24" rx="2" fill="#e8004e" opacity=".4"/>
          <rect x="19" y="27" width="5" height="24" rx="1" fill="#7a0025" opacity=".4"/>
          <path d="M8 27 Q8 13 17 7 Q26 13 26 27 Z" fill="#d0003f"/>
          <path d="M8 27 Q8 13 17 7 L17 27 Z" fill="#f0005a" opacity=".35"/>
          <path d="M17 7 Q26 13 26 27 L21 27 Q21 14 17 7Z" fill="#880028" opacity=".38"/>
          <path d="M11 25 Q12 14 15 10" stroke="#fff" strokeWidth="1" strokeLinecap="round" opacity=".28"/>
        </svg>
      </div>
    </div>
  );
}

export default function App() {
  const { d, h, m, s } = useCountdown();
  const [email, setEmail]       = useState("");
  const [submitted, setSubmitted] = useState(false);

  function handleNotify() {
    if (!email || !email.includes("@")) return;
    setSubmitted(true);
  }

  useEffect(() => {
    const page = document.getElementById("lw-page");
    if (!page) return;
    const colors = ["#c9a96e", "#fff", "#b89050"];
    for (let i = 0; i < 18; i++) {
      const p = document.createElement("div");
      const sz = Math.random() * 2 + 0.8;
      Object.assign(p.style, {
        position: "absolute", borderRadius: "50%", pointerEvents: "none",
        width: sz + "px", height: sz + "px",
        background: colors[Math.floor(Math.random() * colors.length)],
        left: Math.random() * 100 + "%",
        opacity: 0,
        animation: `lwFloat ${Math.random() * 16 + 10}s linear ${Math.random() * 10}s infinite`,
      });
      page.appendChild(p);
    }
  }, []);

  return (
    <>
      <style>{`
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@1,400;1,500&family=Cormorant+Garamond:ital,wght@1,300;1,400&family=Montserrat:wght@200;300;400&display=swap');
        * { margin:0; padding:0; box-sizing:border-box; }
        body { background:#0a0a0a; }
        @keyframes lwFloat {
          0%   { transform:translateY(100vh); opacity:0; }
          10%  { opacity:.22; }
          90%  { opacity:.07; }
          100% { transform:translateY(-5vh); opacity:0; }
        }
        @keyframes lwFadeUp {
          from { opacity:0; transform:translateY(18px); }
          to   { opacity:1; transform:translateY(0); }
        }
        @keyframes lwBobble {
          0%,100% { transform:translateY(0); }
          50%     { transform:translateY(5px); }
        }
        @keyframes lwExpandD {
          from { width:0; opacity:0; }
          to   { width:48px; opacity:.6; }
        }
        .lw-page {
          min-height:100vh;
          background:radial-gradient(ellipse at 60% 20%, #3a2a10 0%, #1a1208 40%, #0a0a0a 100%);
          display:flex; flex-direction:column; align-items:center; justify-content:center;
          position:relative; overflow:hidden; font-family:'Montserrat',sans-serif; padding:60px 24px;
        }
        .lw-logo-circle {
          width:120حء; height:120حء; border-radius:50%; border:1px solid #5a4a2a;
          display:flex; align-items:center; justify-content:center;
          margin-bottom:32px; position:relative; z-index:2;
          animation: lwFadeUp 1s ease both;
        }
        .lw-lulwow {
         font-family:'Playfair Display',serif;
font-style:italic;
font-weight:400;
font-size:clamp(38px,9vw,78px);
letter-spacing:.18em;
color:'#fff !important';
          animation: lwFadeUp 1.1s ease both;
        }
        .lw-beauty {
          font-family:'Montserrat',sans-serif; font-weight:300;
          font-size:clamp(10px,1.8vw,14px); color:#c9a96e;
          letter-spacing:.55em; text-transform:uppercase;
          margin-top:10px; animation: lwFadeUp 1.3s ease both;
        }
        .lw-divider {
          height:.5px; background:#c9a96e; margin:28px auto;
          animation: lwExpandD 1.8s ease both;
        }
        .lw-coming {
         font-family:'Playfair Display',serif;
font-style:italic;
font-weight:400;
font-size:clamp(38px,9vw,78px);
letter-spacing:.18em;
          animation: lwFadeUp 1.5s ease both;
        }
        .lw-tagline {
          font-size:10px; font-weight:300; color:#4a3a20;
          letter-spacing:.35em; text-transform:uppercase;
          margin-top:10px; animation: lwFadeUp 1.7s ease both;
        }
        .lw-countdown {
          display:flex; gap:20px; margin:36px 0 28px;
          position:relative; z-index:2;
          animation: lwFadeUp 1.8s ease both;
        }
        .lw-count-box { display:flex; flex-direction:column; align-items:center; gap:3px; }
        .lw-count-num {
          font-family:'Cormorant Garamond',serif; font-size:38px; font-weight:300;
          color:#fff; line-height:1; min-width:52px; text-align:center;
        }
        .lw-count-sep {
          font-family:'Cormorant Garamond',serif; font-size:26px;
          color:#2e2e2e; align-self:flex-start; margin-top:6px;
        }
        .lw-count-lbl { font-size:8px; letter-spacing:.28em; color:#3a3a3a; text-transform:uppercase; }
        .lw-email-section {
          position:relative; z-index:2; margin-bottom:40px; width:min(420px,90vw);
          animation: lwFadeUp 2s ease both;
        }
        .lw-email-label {
          font-size:10px; letter-spacing:.25em; color:#444;
          text-transform:uppercase; text-align:center; margin-bottom:14px;
        }
        .lw-email-field { position:relative; display:flex; align-items:stretch; }
        .lw-email-icon {
          position:absolute; left:16px; top:50%; transform:translateY(-50%);
          color:#3a3a3a; pointer-events:none; display:flex; align-items:center;
        }
        .lw-email-input {
          width:100%; background:rgba(255,255,255,.03); border:.5px solid #222;
          border-radius:2px 0 0 2px; outline:none;
          padding:15px 16px 15px 42px;
          font-family:'Montserrat',sans-serif; font-size:11px;
          letter-spacing:.12em; color:#bbb; transition:border-color .3s;
        }
        .lw-email-input:focus { border-color:#c9a96e; }
        .lw-email-input::placeholder { color:#2e2e2e; }
        .lw-email-btn {
          background:#c9a96e; border:none; border-radius:0 2px 2px 0;
          padding:15px 26px; cursor:pointer;
          font-family:'Montserrat',sans-serif; font-size:9px;
          letter-spacing:.3em; color:#0c0c0c; font-weight:400;
          text-transform:uppercase; white-space:nowrap; transition:background .3s;
        }
        .lw-email-btn:hover { background:#d4b87d; }
        .lw-email-hint { font-size:9px; letter-spacing:.15em; color:#2a2a2a; text-align:center; margin-top:10px; text-transform:uppercase; }
        .lw-success {
          border:.5px solid rgba(201,169,110,.2); border-radius:2px;
          padding:20px 32px; text-align:center;
        }
        .lw-success-label { font-size:11px; letter-spacing:.2em; color:#c9a96e; text-transform:uppercase; margin-top:10px; }
        .lw-success-sub   { font-size:9px;  letter-spacing:.15em; color:#333; margin-top:6px; text-transform:uppercase; }
        .lw-scroll-btn {
          margin-top:8px; width:42px; height:42px; border-radius:50%;
          border:.5px solid #3a2e1a; display:flex; align-items:center; justify-content:center;
          cursor:pointer; position:relative; z-index:2;
          animation: lwFadeUp 2.1s ease both, lwBobble 2.5s ease-in-out 2s infinite;
        }
        .lw-arrow { width:11px; height:11px; border-right:1px solid #c9a96e; border-bottom:1px solid #c9a96e; transform:rotate(45deg); margin-top:-4px; }
        .lw-bottom-strip {
          display:flex; gap:24px; position:relative; z-index:2; margin-top:32px;
          animation: lwFadeUp 2.2s ease both;
        }
        .lw-strip-item { font-size:9px; letter-spacing:.25em; color:#282828; text-transform:uppercase; transition:color .3s; cursor:default; }
        .lw-strip-item:hover { color:#fff; }
        .lw-strip-dot { color:#1e1e1e; font-size:9px; }
      `}</style>

      <div className="lw-page" id="lw-page">

        {/* logo */}
        <div className="lw-logo-circle">
          {/* <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
            <circle cx="30" cy="30" r="28" stroke="#5a4a2a" strokeWidth=".8"/>
            <path d="M6 30 Q18 10 30 30 Q42 50 54 30 Q42 10 30 30 Q18 50 6 30Z" stroke="#8a7040" strokeWidth=".7" fill="none"/>
            <path d="M30 21 L32.8 28.2 L40 30 L32.8 31.8 L30 39 L27.2 31.8 L20 30 L27.2 28.2Z" fill="#c9a96e"/>
          </svg> */}

          <img src={logo} alt="LULWOW Logo" style={{width:'70px',height:'65px'}}/>
        </div>

        {/* brand name + lipstick */}
        <div style={{ position: "relative", zIndex: 2, textAlign: "center" }}>
          <div style={{ display: "inline-block" }}>
            <div className="lw-lulwow" style={{color:'#c7c4c4'}}>LULWOW</div>
            <LipstickUnderline />
          </div>
          <div className="lw-beauty">Beauty</div>
        </div>

        {/* divider */}
        <div className="lw-divider" style={{ width: 48 }} />

        {/* coming soon */}
        <div className="lw-coming" style={{ position: "relative", zIndex: 2 ,color:'#c7c4c4'}}>Coming Soon</div>
        <div className="lw-tagline" style={{ position: "relative", zIndex: 2 }}>Where beauty meets ritual</div>

        {/* countdown */}
        <div className="lw-countdown">
          <div className="lw-count-box"><span className="lw-count-num">{d}</span><span className="lw-count-lbl">Days</span></div>
          <span className="lw-count-sep">·</span>
          <div className="lw-count-box"><span className="lw-count-num">{h}</span><span className="lw-count-lbl">Hours</span></div>
          <span className="lw-count-sep">·</span>
          <div className="lw-count-box"><span className="lw-count-num">{m}</span><span className="lw-count-lbl">Mins</span></div>
          <span className="lw-count-sep">·</span>
          <div className="lw-count-box"><span className="lw-count-num">{s}</span><span className="lw-count-lbl">Secs</span></div>
        </div>

        {/* notify me */}
        <div className="lw-email-section">
          {submitted ? (
            <div className="lw-success">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#c9a96e" strokeWidth="1.5" strokeLinecap="round" style={{ display: "block", margin: "0 auto" }}>
                <path d="M20 6L9 17l-5-5"/>
              </svg>
              <p className="lw-success-label">You're on the list</p>
              <p className="lw-success-sub">See you soon ✦</p>
            </div>
          ) : (
            <>
              <p className="lw-email-label">Be the first to know</p>
              <div className="lw-email-field">
                <span className="lw-email-icon">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 7l10 7 10-7"/>
                  </svg>
                </span>
                <input
                  className="lw-email-input"
                  type="email"
                  placeholder="your@email.com"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  onKeyDown={e => e.key === "Enter" && handleNotify()}
                />
                <button className="lw-email-btn" onClick={handleNotify}>Notify Me</button>
              </div>
              <p className="lw-email-hint">No spam. Just beauty.</p>
            </>
          )}
        </div>

        {/* scroll arrow */}
        <div className="lw-scroll-btn"><div className="lw-arrow"/></div>

        {/* bottom strip */}
        <div className="lw-bottom-strip">
          <span className="lw-strip-item" style={{color:'#fff'}}>Skincare</span>
          <span className="lw-strip-dot"  >·</span>
          <span className="lw-strip-item" style={{color:'#fff'}}>Makeup</span>
          <span className="lw-strip-dot">·</span>
          <span className="lw-strip-item" style={{color:'#fff'}}>Wellness</span>
          <span className="lw-strip-dot">·</span>
          <span className="lw-strip-item"   style={{color:'#fff'}}>Rituals</span>
        </div>

      </div>
    </>
  );
}
